module.exports = __webpack_public_path__ + "img/logo-white.3aa9e349.svg";